// src/utils/reloader.ts
import { ref } from 'vue'

const reloadKey = ref(0)

export function useReloadKey() {
  return reloadKey
}

export function bumpReloadKey() {
  reloadKey.value++
}